import React, { useState } from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  HStack,
  Button
} from '@chakra-ui/react';
import { NoticeMessageType } from '../../../pages/NoticeMessageList';
import { ObcMessageTable } from './ObcMessageTable';
import { TramMessageTable } from './TramMessageTable';
import { MessageInfoExists } from './NoticeMessageListBody';
import { DivisionEnum } from '../Message/MessageBody';
import { LocationMessageTable } from './LocationMessageTable';

interface props {
  isOpen: boolean;
  onClose: () => void;
  MessageData: NoticeMessageType | undefined;
}

const DispTableEnum = {
  None: 0,
  Obc: 1,
  Tram: 2,
  Location: 3
};

export const StatusModalWindow: React.FC<props> = (props) => {
  const { isOpen, onClose, MessageData } = props;

  const trainExists =
    MessageData !== undefined
      ? MessageInfoExists(MessageData, DivisionEnum.Train)
      : false;

  const tramExists =
    MessageData !== undefined
      ? MessageInfoExists(MessageData, DivisionEnum.Tram)
      : false;

  const locationExists =
    MessageData !== undefined
      ? MessageInfoExists(MessageData, DivisionEnum.Location)
      : false;

  const GetInitDispTableType = () => {
    if (trainExists) {
      return DispTableEnum.Obc;
    } else if (tramExists) {
      return DispTableEnum.Tram;
    } else if (locationExists) {
      return DispTableEnum.Location;
    }
    return DispTableEnum.None;
  };

  const [dispTableType, setDispTableType] = useState(GetInitDispTableType());

  return (
    <>
      <Modal isOpen={isOpen} onClose={onClose} isCentered>
        <ModalOverlay />
        <ModalContent h='600px' maxW='1400px'>
          <ModalHeader
            textAlign='center'
            bg='gray.800'
            color='white'
            fontSize='16'
          >
            {'通知メッセージ一覧'}
          </ModalHeader>
          <ModalCloseButton color='white' />
          <ModalBody h='100%'>
            <HStack mt={2}>
              {trainExists && (
                <Button
                  _hover={{ bgColor: '' }}
                  _focus={{ bgColor: '' }}
                  bgColor={
                    dispTableType === DispTableEnum.Obc ? 'blackAlpha.500' : ''
                  }
                  onClick={() => setDispTableType(DispTableEnum.Obc)}
                >
                  Obc
                </Button>
              )}
              {tramExists && (
                <Button
                  _hover={{ bgColor: '' }}
                  _focus={{ bgColor: '' }}
                  bgColor={
                    dispTableType === DispTableEnum.Tram ? 'blackAlpha.500' : ''
                  }
                  onClick={() => setDispTableType(DispTableEnum.Tram)}
                >
                  停留場
                </Button>
              )}
              {locationExists && (
                <Button
                  _hover={{ bgColor: '' }}
                  _focus={{ bgColor: '' }}
                  bgColor={
                    dispTableType === DispTableEnum.Location
                      ? 'blackAlpha.500'
                      : ''
                  }
                  onClick={() => setDispTableType(DispTableEnum.Location)}
                >
                  位置情報
                </Button>
              )}
            </HStack>
            {dispTableType === DispTableEnum.Obc && (
              <HStack spacing='0' h='76%' mt={5}>
                <ObcMessageTable
                  MessageDataList={MessageData?.messageTrainsData}
                  DivisionText={'送信済み'}
                  DivisionColor={'#5CACE2'}
                  isComplete={true}
                />
                <ObcMessageTable
                  MessageDataList={MessageData?.messageTrainsData}
                  DivisionText={'未送信'}
                  DivisionColor={'#E74C3C'}
                  isComplete={false}
                />
              </HStack>
            )}
            {dispTableType === DispTableEnum.Tram && (
              <HStack spacing='0' h='70%' mt={5}>
                <TramMessageTable
                  MessageDataList={MessageData?.messageSignagesData}
                />
              </HStack>
            )}
            {dispTableType === DispTableEnum.Location && (
              <HStack spacing='0' h='22%' mt={5}>
                <LocationMessageTable
                  MessageLocationData={MessageData?.messageLocationData}
                />
              </HStack>
            )}
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};
